var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { chartConfig, pieChartConfig } from '../../app.constants';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import { UserService } from '../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
var AchooPieChartComponent = /** @class */ (function () {
    function AchooPieChartComponent(pdfService, userService, translate, deviceService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.translate = translate;
        this.deviceService = deviceService;
        this.listLegendPlaceholder = [];
        this.forPayingUser = false;
        this.isDemographicPage = false;
        this.isUseInInfluencerOverviewReport = false;
        this.applyResponsive = true;
    }
    AchooPieChartComponent.prototype.ngOnInit = function () {
        if (!this.fallbackMsg) {
            this.fallbackMsg = this.translate.instant('measure.noData');
        }
        var spacingTop = this.chartConfig && this.chartConfig.spacingTop ? this.chartConfig.spacingTop : chartConfig.defaultSpacingTop;
        var spacingLeft = this.chartConfig && this.chartConfig.spacingLeft ? this.chartConfig.spacingLeft : chartConfig.defaultSpacingLeft;
        var enabledNavigation = this.legend.enabledNavigation !== undefined ? this.legend.enabledNavigation : true;
        this.options = {
            chart: {
                type: chartConfig.type.pie,
                width: this.width,
                height: this.height,
                backgroundColor: chartConfig.transparentBackground,
                spacingTop: spacingTop,
                spacingLeft: spacingLeft,
                spacingRight: this.getConfigValue(this.chartConfig && this.chartConfig.spacingRight, chartConfig.defaultSpacingRight),
                style: {
                    fontFamily: chartConfig.font.light
                },
            },
            colors: this.userService.chartColors,
            tooltip: {
                enabled: false
            },
            plotOptions: {
                pie: this.getPiePlotOptions(),
                series: {
                    animation: !this.pdfService.exportingPdf
                }
            },
            legend: {
                symbolHeight: this.legend.symbolHeight || pieChartConfig.defaultLegendSymbolSize,
                symbolWidth: this.legend.symbolWidth || pieChartConfig.defaultLegendSymbolSize,
                symbolRadius: this.legend.symbolRadius || pieChartConfig.defaultLegendSymbolRadius,
                verticalAlign: this.legend.verticalAlign || 'top',
                y: this.getConfigValue(this.legend.y, this.getLegendY()),
                x: this.legend.x || pieChartConfig.defaultLegendX,
                align: this.legend.align || 'right',
                layout: 'vertical',
                width: this.legend.width || chartConfig.defaultLegendStyle.defaultSize,
                padding: this.legend.padding || pieChartConfig.defaultLegendPadding,
                itemHiddenStyle: this.getConfigValue(this.legend.itemHiddenStyle, { color: '#cccccc' }),
                itemMarginTop: chartConfig.defaultLegendStyle.marginTop,
                maxHeight: this.deviceService.isMobile() ? chartConfig.defaultLegendStyle.mobileSize : chartConfig.defaultLegendStyle.defaultSize,
                navigation: {
                    enabled: enabledNavigation,
                    activeColor: this.getConfigValue(this.legend.navigationActiveColor, pieChartConfig.defaultNavigationActiveColor),
                    inactiveColor: this.getConfigValue(this.legend.navigationInactiveColor, pieChartConfig.defaultNavigationInactiveColor),
                    arrowSize: this.getConfigValue(this.legend.navigationArrowSize, pieChartConfig.defaultNavigationArrowSize)
                },
                floating: this.getConfigValue(this.legend.floating, false),
                useHTML: this.legend.useHTML || false,
                labelFormatter: function () {
                    // legend text
                    var text = this.name;
                    var labelMaxCharacterSize = this.labelMaxCharacterSize || chartConfig.legend.labelMaxCharacterSize;
                    if (text.length > labelMaxCharacterSize) {
                        text = text.slice(0, chartConfig.legend.labelMaxCharacterSize) + '...';
                    }
                    var labelHtml = '<div class="label-text">' + text + ' ' + '</div>';
                    // value text
                    var valueDisplay = '';
                    if (this.customLegendDisplay) {
                        valueDisplay = this.customLegendDisplay;
                    }
                    else {
                        var percentageDisplay = '-';
                        if (!this.isPlaceholder) {
                            var yPercentage = this.y * 100;
                            var fracDigit = this.fracDigit || 0;
                            percentageDisplay = yPercentage.toFixed(fracDigit);
                        }
                        valueDisplay = percentageDisplay + "%";
                    }
                    var valueHTML = "<div class=\"percentage\">" + valueDisplay + "</div";
                    return '<div class="legend-label">'
                        + labelHtml
                        + valueHTML
                        + '</div>';
                }
            },
            credits: {
                enabled: false
            },
            title: {
                text: this.chartTitle,
                // REVIEW: Do we need to add this elsewhere?
                style: Object.assign({}, chartConfig.defaultTitleStyling, this.titleStyling),
                align: chartConfig.title.align,
                x: !this.isDemographicPage ? chartConfig.title.padding : chartConfig.title.paddingLeft,
                y: !this.isDemographicPage ? chartConfig.title.padding : chartConfig.title.paddingTop
            },
            series: [this.getSeriesConfig()],
            responsive: this.getResposive()
        };
    };
    Object.defineProperty(AchooPieChartComponent.prototype, "noDataAvailable", {
        get: function () {
            if (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin) {
                return true;
            }
            if (!this.chartData || this.chartData.length === 0) {
                return true;
            }
            return this.chartData.filter(function (p) { return p.y > 0; }).length === 0;
        },
        enumerable: true,
        configurable: true
    });
    AchooPieChartComponent.prototype.getLegendY = function () {
        var length = this.chartData ? this.chartData.length : 0;
        return length >= 10 ? 20 : 30;
    };
    AchooPieChartComponent.prototype.getConfigValue = function (configValue, defaultValue) {
        if (configValue === null || configValue === undefined) {
            return defaultValue;
        }
        return configValue;
    };
    AchooPieChartComponent.prototype.getSeriesConfig = function () {
        var defaultConfig = {
            data: this.chartData,
            size: this.deviceService.isMobile() ? chartConfig.pieChart.mobileSize : this.pieSize || chartConfig.pieChart.size,
            innerSize: this.pieInnerSize || chartConfig.pieChart.innerSize
        };
        return this.overridenSeriesConfig
            ? __assign({}, defaultConfig, this.overridenSeriesConfig) : defaultConfig;
    };
    AchooPieChartComponent.prototype.getPiePlotOptions = function () {
        var defaultOptions = {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
                enabled: false
            },
            showInLegend: true,
            center: this.pieCenter || pieChartConfig.defaultPieCenter
        };
        return this.overridenPiePlotOptions
            ? __assign({}, defaultOptions, this.overridenPiePlotOptions) : defaultOptions;
    };
    AchooPieChartComponent.prototype.getResposive = function () {
        return this.applyResponsive
            ? {
                rules: [{
                        condition: {
                            maxWidth: pieChartConfig.smallPieSize
                        },
                        chartOptions: {
                            legend: {
                                align: 'right',
                                verticalAlign: 'top',
                                layout: 'vertical',
                                x: this.deviceService.isMobile() ? pieChartConfig.mobileLegendX : pieChartConfig.defaultSmallChartLegendX,
                                itemStyle: {
                                    'fontSize': '11px'
                                }
                            },
                            chart: {
                                height: this.height,
                                spacingLeft: pieChartConfig.defaultChartSpacingLeft,
                                spacingRight: pieChartConfig.defaultChartSpacingRight,
                                spacingTop: pieChartConfig.defaultChartSpacingTop,
                                marginLeft: this.deviceService.isMobile() ? pieChartConfig.mobileChartMarginLeft : !this.pdfService.exportingPdf && this.isUseInInfluencerOverviewReport ? pieChartConfig.defaultTitleX : pieChartConfig.chartMarginLeft
                            },
                            title: {
                                style: this.deviceService.isMobile() ? chartConfig.mobileTitleStyling : Object.assign({}, chartConfig.defaultTitleStyling, this.titleStyling),
                                x: !this.isDemographicPage ? pieChartConfig.defaultTitleX : chartConfig.title.paddingLeft,
                                y: pieChartConfig.defaultTitleY
                            },
                            plotOptions: {
                                pie: {
                                    center: this.deviceService.isMobile() ? pieChartConfig.mobilePieCenter : (this.pieCenter && this.pieCenter.length !== 0) ? this.pieCenter : pieChartConfig.smallPieCenter
                                }
                            }
                        }
                    }]
            }
            : {
                rules: []
            };
    };
    return AchooPieChartComponent;
}());
export { AchooPieChartComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-pie-chart/achoo-pie-chart.component.ts.pre-build-optimizer.js